module.exports = __webpack_public_path__ + "static/img/b3.ca3019b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/tutorial2/b3.jpg
// module id = NnVm
// module chunks = 14